module.exports = __webpack_public_path__ + "img/man-body-upper-front.47397e88.png";